import { cct } from 'src/utils/creditCardsI18n'

export const operationHasDocumentAssignment = (op) => Boolean(op?.associatedDocumentId)

/** Period TC chip: unassigned ops inherit the statement obligation unless unmatch suppressed it. */
export const showPeriodTcObligationChip = (op, periodObligationId) =>
  !operationHasDocumentAssignment(op) &&
  Boolean(periodObligationId) &&
  !op?.suppressPeriodTcObligation

/** Ops eligible for multi-select bulk assign (no invoice, no account). DIFFERENCE rows are never ops. */
export const isOperationEligibleForBulkAssignment = (op) => {
  if (!op) return false
  if (operationHasDocumentAssignment(op)) return false
  if ((op.allocations || []).some((a) => a.type === 'INVOICE')) return false
  if (String(op.accountKey || '').trim()) return false
  return true
}

export const isInternationalStatementAmount = (statementAmountCurrency) =>
  String(statementAmountCurrency || '').toUpperCase() === 'USD'

export const formatStatementChargeAmount = (n, statementAmountCurrency) => {
  const num = Number(n)
  if (isInternationalStatementAmount(statementAmountCurrency)) {
    return `US$ ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
  return `$${num.toLocaleString('es-CL')}`
}

const EXTRACTED_OPS_COLUMNS_LEFT = [
  {
    key: 'date',
    get label() { return cct('cols.date') },
    get hint() { return cct('cols.dateHint') },
    align: 'left',
  },
  {
    key: 'description',
    get label() { return cct('cols.operation') },
    get hint() { return cct('cols.operationHint') },
    align: 'left',
  },
]

/** Factura, cuenta y obligación van al extremo derecho de la tabla, en este orden. */
const EXTRACTED_OPS_COLUMNS_ASSIGNMENT_RIGHT = [
  {
    key: 'document',
    get label() { return cct('cols.document') },
    get hint() { return cct('cols.documentHint') },
    align: 'right',
  },
  {
    key: 'account',
    get label() { return cct('cols.account') },
    get hint() { return cct('cols.accountHint') },
    align: 'right',
  },
  {
    key: 'obligation',
    get label() { return cct('cols.obligation') },
    get hint() { return cct('cols.obligationHint') },
    align: 'right',
  },
]

export const EXTRACTED_OPS_COLUMN_HEADERS_NATIONAL = [
  ...EXTRACTED_OPS_COLUMNS_LEFT,
  {
    key: 'totalAmount',
    get label() { return cct('cols.totalAmount') },
    get hint() { return cct('cols.totalAmountHint') },
    align: 'right',
  },
  {
    key: 'amount',
    get label() { return cct('cols.monthAmount') },
    get hint() { return cct('cols.monthAmountHint') },
    align: 'right',
  },
  ...EXTRACTED_OPS_COLUMNS_ASSIGNMENT_RIGHT,
]

export const EXTRACTED_OPS_COLUMN_HEADERS_INTERNATIONAL = [
  ...EXTRACTED_OPS_COLUMNS_LEFT,
  {
    key: 'totalAmount',
    get label() { return cct('cols.originalAmount') },
    get hint() { return cct('cols.originalAmountHint') },
    align: 'right',
  },
  {
    key: 'amount',
    get label() { return cct('cols.localAmount') },
    get hint() { return cct('cols.localAmountHint') },
    align: 'right',
  },
  ...EXTRACTED_OPS_COLUMNS_ASSIGNMENT_RIGHT,
]

export const formatUsdToClpExchangeRate = (rate) => {
  const n = Number(rate)
  if (!Number.isFinite(n) || n <= 0) return '—'
  return n.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** @deprecated use getExtractedOpsColumnHeaders */
export const EXTRACTED_OPS_COLUMN_HEADERS = EXTRACTED_OPS_COLUMN_HEADERS_NATIONAL

export const getExtractedOpsColumnHeaders = (statementAmountCurrency) =>
  isInternationalStatementAmount(statementAmountCurrency)
    ? EXTRACTED_OPS_COLUMN_HEADERS_INTERNATIONAL
    : EXTRACTED_OPS_COLUMN_HEADERS_NATIONAL

